
// added so later we can keep breakpoint in sync automatically using this config file
// import tailwindConfig from "../../tailwind.config.js"

const getters = {

	// COMPONENT
		// vx-autosuggest
	// starredPages: state => state.navbarSearchAndPinList.data.filter((page) => page.highlightAction),
  windowBreakPoint: state => {

    // This should be same as tailwind. So, it stays in sync with tailwind utility classes
    if (state.windowWidth >= 1200) return "xl"
    else if (state.windowWidth >= 992) return "lg"
    else if (state.windowWidth >= 768) return "md"
    else if (state.windowWidth >= 576) return "sm"
    else return "xs"
  },

  getCountry:(state) => {
    if(!state.country.code) return null
    return state.countries.find((con) => con.code == state.country.code);
  },

  authToken: (state) => {
    const stored = localStorage.getItem(state.localUserKey);
    if (!stored) return null;

    try {
      const decoded = JSON.parse(unescape(atob(stored)));
      const isExpired = new Date(decoded.tokenExpirationDate) < new Date();
      return isExpired ? null : decoded.token;
    } catch (e) {
      console.error("Failed to parse auth token:", e);
      return null;
    }
  }
}

export default getters
